import Marquee from 'react-fast-marquee';
import { useEffect, useState } from 'react';
import api from '@/lib/api';
import useBinanceTickers from '@/hooks/useBinanceTickers';

export default function LiveTicker() {
  const [coins, setCoins] = useState([]);
  const tickers = useBinanceTickers();

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const res = await api.get('/markets');
        if (alive) setCoins(res.data.markets.slice(0, 20));
      } catch (_e) { /* ignore */ }
    };
    load();
    const iv = setInterval(load, 60000);
    return () => { alive = false; clearInterval(iv); };
  }, []);

  if (!coins.length) return <div className="h-10 bg-[#181A20] border-y border-[#2B3139]" />;

  return (
    <div className="bg-[#181A20] border-y border-[#2B3139] py-2.5" data-testid="live-ticker">
      <Marquee gradient={false} speed={40} pauseOnHover>
        {coins.map((c) => {
          const sym = c.symbol.toUpperCase();
          const live = tickers[sym];
          const price = live?.price ?? c.current_price;
          const change = live?.changePct ?? c.price_change_percentage_24h;
          const up = (change ?? 0) >= 0;
          const dir = live?.dir;
          return (
            <div key={c.id} className="flex items-center gap-2 px-6 text-sm">
              <img src={c.image} alt="" className="w-4 h-4" />
              <span className="text-white font-medium">{sym}</span>
              <span className={`font-mono transition-colors ${dir === 'up' ? 'text-[#0ECB81]' : dir === 'down' ? 'text-[#F6465D]' : 'text-[#EAECEF]'}`}>
                ${price?.toLocaleString(undefined, { maximumFractionDigits: price < 1 ? 6 : 2 })}
              </span>
              <span className={`font-mono text-xs ${up ? 'text-[#0ECB81]' : 'text-[#F6465D]'}`}>
                {up ? '+' : ''}{change?.toFixed(2)}%
              </span>
            </div>
          );
        })}
      </Marquee>
    </div>
  );
}
